export class ProviderVerifyRecoverDeleteRequest {
  token: string;

  constructor(token: string) {
    this.token = token;
  }
}
